"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { SvgIconType } from '../SvgIcon/svg-icon-type.mjs';
import useEventStopPropagation from '../../helpers/hooks/useEventStopPropagation.mjs';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { forwardRef } from 'react';
import { tv } from 'tailwind-variants';
import { SvgIcon } from '../SvgIcon/index.mjs';
import { Tooltip } from '../Tooltip/index.mjs';

const dataBuilderActionBarRecipe = tv({
  slots: withSlotScopeClasses("data-builder-action-bar", {
    root: "flex flex-col items-center justify-center gap-1 w-5 -ml-0.5 -mr-2.5",
    button: [
      "flex shrink-0 grow-0 justify-center items-center w-5 h-5",
      "border border-solid border-border-muted bg-bg-subtle text-fg-subtle",
      "hover:bg-bg-emphasized",
      "[&>svg]:w-3 [&>svg]:h-3 [&>svg]:stroke-2"
    ]
  })
});
const ActionBarRoot = forwardRef(
  ({ children, className, ...props }, ref) => {
    const styles = dataBuilderActionBarRecipe();
    return /* @__PURE__ */ jsx("div", { className: styles.root({ className }), ...props, ref, children });
  }
);
ActionBarRoot.displayName = "ActionBarRoot";
const ActionBarDeleteButton = forwardRef(
  ({ className, onClick, ...props }, ref) => {
    const styles = dataBuilderActionBarRecipe();
    const handleOnClick = useEventStopPropagation(
      (e) => onClick?.(e)
    );
    return /* @__PURE__ */ jsx(Tooltip, { tooltip: "Delete", className: styles.root(), usePortal: true, children: /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: styles.button({ className }),
        onClick: handleOnClick,
        "aria-label": "Delete",
        ...props,
        ref,
        children: /* @__PURE__ */ jsx(SvgIcon, { type: SvgIconType.Close })
      }
    ) });
  }
);
ActionBarDeleteButton.displayName = "ActionBarDeleteButton";
const ActionBar = Object.assign(ActionBarRoot, {
  DeleteButton: ActionBarDeleteButton
});

export { ActionBar };
